'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addReducers = exports.addReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Add all of your reducers when you need it
 * @param {ReduxStore} store You redux store
 * @param {Object} reducers Reducers object with the format { reducerName: reducer }
 */
function addReducers(store, reducers) {
    if (!store.asyncReducers) {
        store.asyncReducers = {};
    }

    store.asyncReducers = _extends({}, store.asyncReducers, reducers);

    store.replaceReducer((0, _redux.combineReducers)(_extends({}, store.asyncReducers)));
}

/**
 * Add a reducer when you need it
 * @param {ReduxStore} store You redux store
 * @param {String} name The Reducer's name
 * @param {Function} reducer Your reducer
 */
function addReducer(store, name, reducer) {
    if (!store.asyncReducers) {
        store.asyncReducers = {};
    }

    store.asyncReducers[name] = reducer;
    store.replaceReducer((0, _redux.combineReducers)(_extends({}, store.asyncReducers)));

    addReducers(store, _defineProperty({}, name, reducer));
}

exports.default = {
    addReducer: addReducer,
    addReducers: addReducers
};
exports.addReducer = addReducer;
exports.addReducers = addReducers;